module.exports = __webpack_public_path__ + "static/img/success_icon@3x.e0974e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/active/success_icon@3x.png
// module id = Z/sr
// module chunks = 1